function decodeNumericEntity(_, dec, hex) {
    const code = dec !== undefined ? Number(dec) : parseInt(hex, 16);
    return code <= 0x10ffff ? String.fromCodePoint(code) : 'x';
}
/**
 * Markup-only content (`<p></p>`, `<p>&nbsp;</p>`, `<p>&#32;</p>`) counts as empty;
 * numeric entities count by the character they encode, other entities as visible.
 */
export function hasVisibleText(html) {
    const text = html
        .replace(/<[^>]*>/g, '')
        .replace(/&#(?:(\d+)|x([0-9a-f]+));/gi, decodeNumericEntity)
        .replace(/&(?:nbsp|ensp|emsp|thinsp);/gi, ' ')
        .replace(/&[a-z0-9]+;/gi, 'x')
        .trim();
    return text.length > 0;
}
//# sourceMappingURL=blank-html.js.map